import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { NewGameListJson } from '@/views/system/homePage/server';

export interface HomeNewGameProp {
  list: NewGameListJson;
  titleList: string[];
  dateId: string;
  current: number;
  loading: boolean;
  clientTime: number;
}
export interface HomeNewGameState {
  '1': HomeNewGameProp;
  '2': HomeNewGameProp;
  '3': HomeNewGameProp;
  '5': HomeNewGameProp;
  '6': HomeNewGameProp;
}

const NEWGAME_KEY = 'React-ts-ant-homeNewGame';

const localHomeNewGames = LocalStore.getValue<HomeNewGameState>(NEWGAME_KEY) || {};

export const defaults: HomeNewGameState = {
  '1': {
    list: {},
    titleList: [],
    dateId: '',
    current: 0,
    loading: true,
    clientTime: 0
  },
  '2': {
    list: {},
    titleList: [],
    dateId: '',
    current: 0,
    loading: true,
    clientTime: 0
  },
  '3': {
    list: {},
    titleList: [],
    dateId: '',
    current: 0,
    loading: true,
    clientTime: 0
  },
  '5': {
    list: {},
    titleList: [],
    dateId: '',
    current: 0,
    loading: true,
    clientTime: 0
  },
  '6': {
    list: {},
    titleList: [],
    dateId: '',
    current: 0,
    loading: true,
    clientTime: 0
  },
  ...localHomeNewGames
};

const HOME_NEWGAME_KEY = 'React-ts-ant-HOMENEWGAME';

export const updateHomeNewGames: (homePages: HomeNewGameState) => IAction<HomeNewGameState> = (
  homePages: HomeNewGameState
) => ({
  type: HOME_NEWGAME_KEY,
  payload: homePages
});

const homeNewGameReducer: Reducer<HomeNewGameState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_NEWGAME_KEY:
      LocalStore.setValue(NEWGAME_KEY, payload as HomeNewGameState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeNewGameReducer;
